import React from "react";
import { MessageDescriptor, useIntl } from "react-intl";

interface IProps extends MessageDescriptor {
    values?: Record<string, string | number | boolean | null | undefined | Date>,
}

/**
 * What react-intl's FormattedHTMLMessage did, and what react-intl stopped shipping in
 * version 4: render a message that has markup of its own in it.
 *
 * The messages are the project's own - they come from the token table, written by the
 * people who maintain the translations - so the markup in them is meant to be rendered
 * rather than shown. The rendered element is a span, which is what the component this
 * replaces produced, so the markup around it is unchanged.
 */
const FormattedHtmlMessage = ({ values, ...descriptor }: IProps) => {
    const { formatMessage } = useIntl();
    // ignoreTag, because the markup in these messages is markup and not react-intl's rich
    // text syntax: without it the parser reads <a href="..."> as a tag it has no handler
    // for, gives up on the message, and renders its id.
    return <span dangerouslySetInnerHTML={{ __html: formatMessage(descriptor, values, { ignoreTag: true }) }} />;
};

export default FormattedHtmlMessage;
